"use strict";

exports.__esModule = true;
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _actions = _interopRequireDefault(require("./actions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  Id: {
    displayName: 'ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  },
  Sub: {
    displayName: 'Sub',
    type: 'String',
    rules: [],
    value: '',
    guarded: true,
    sortable: true,
    filterable: true
  },
  GivenName: {
    displayName: 'First name',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  MiddleName: {
    displayName: 'Middle name',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  FamilyName: {
    displayName: 'Last name',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Email: {
    displayName: 'Email',
    type: 'Email',
    rules: [],
    sortable: true,
    filterable: true
  },
  PhoneNumber: {
    displayName: 'Phone number',
    type: 'Phone',
    rules: [],
    value: '',
    sortable: true
  },
  Nickname: {
    displayName: 'Nickname',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Birthdate: {
    displayName: 'Birth date',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Gender: {
    displayName: 'Gender',
    type: 'Enum',
    options: {
      0: 'Female',
      1: 'Male',
      2: 'NotApplicable',
      3: 'Other',
      4: 'Unknwon'
    },
    rules: {
      isNullable: true
    },
    value: '',
    sortable: true,
    filterable: true
  },
  UserImage: {
    displayName: 'Picture',
    type: 'RelationPicture',
    rules: [],
    value: '',
    format: 'base64',
    entity: {
      local: 'User',
      foreign: 'UserImage'
    },
    add: _actions.default.addPicture,
    update: _actions.default.updatePicture,
    drop: _actions.default.dropPicture,
    sortable: true,
    filterable: false
  },
  ZoneInfo: {
    displayName: 'ZoneInfo',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Locale: {
    displayName: 'Locale',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Type: {
    displayName: 'Type',
    type: 'Enum',
    options: {
      Default: 'Default',
      SolidWhite: 'SolidWhite',
      System: 'System',
      Temporary: 'Temporary'
    },
    guarded: true,
    sortable: true,
    filterable: true
  },
  UserGroups: {
    displayName: 'Assigned groups',
    type: 'Join',
    entities: {
      local: 'User',
      join: 'UserGroups',
      foreign: 'Group',
      filterString: value => `(Name != null and Name.Contains("${value}")) or (Description != null and Description.Contains("${value}")) and CreatorType = "User"`,
      getDisplayName: entity => `${entity.Name}`,
      displayName: 'Name'
    },
    add: _actions.default.addGroup,
    drop: _actions.default.dropGroup,
    sortable: false,
    filterable: false
  },
  UserPermissions: {
    displayName: 'Permissions',
    type: 'Join',
    entities: {
      local: 'User',
      join: 'UserPermissions',
      foreign: 'Permission',
      filterString: value => `(Name != null and Name.Contains("${value}")) or (Value != null and Value.Contains("${value}")) and CreatorType = "User"`,
      getDisplayName: entity => `${entity.Name}`,
      displayName: 'Value'
    },
    add: _actions.default.addPermission,
    drop: _actions.default.dropPermission,
    sortable: false,
    filterable: false
  },
  LastActiveAt: {
    displayName: 'Last active',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    guarded: true,
    sortable: true,
    filterable: true
  },
  UpdatedAt: {
    displayName: 'Updated',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    guarded: true,
    sortable: true,
    filterable: true
  },
  CreatedAt: {
    displayName: 'Created',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    guarded: true,
    sortable: true,
    filterable: true
  }
};
module.exports = exports.default;